import {
  sendAppointmentForm,
  getMotives,
  sendShareForm,
  sendNewsletterForm
} from '../services/popin';

export const TOGGLE_POPIN_APPOINTMENT = 'TOGGLE_POPIN_APPOINTMENT';
export function togglePopinAppointment(dispatch, isOpen, id) {
  dispatch({
    type: TOGGLE_POPIN_APPOINTMENT,
    data: isOpen,
    id
  });
}

export const SUBMIT_POPIN_APPOINTMENT = 'SUBMIT_POPIN_APPOINTMENT';
export function submitPopinAppointment(dispatch, form, confirmation) {
  sendAppointmentForm(form)
    .then(json => dispatch({
      type: SUBMIT_POPIN_APPOINTMENT,
      data: json,
      confirmation,
      form
    }));
}

export const FETCH_MOTIVES = 'FETCH_MOTIVES';
export const MOTIVES_NOT_LOADED = 0;
export const MOTIVES_LOADING = 1;
export const MOTIVES_LOADED = 2;
let motivesLoadState = MOTIVES_NOT_LOADED;
export function fetchMotives(dispatch) {
  if (motivesLoadState === MOTIVES_NOT_LOADED) {
    motivesLoadState = MOTIVES_LOADING;
    getMotives()
      .then(json => dispatch({
        type: FETCH_MOTIVES,
        data: json
      }))
      .then(() => motivesLoadState = MOTIVES_LOADED);
  }
}

export const TOGGLE_POPIN_SHARE = 'TOGGLE_POPIN_SHARE';
export function togglePopinShare(dispatch, isOpen, id) {
  dispatch({
    type: TOGGLE_POPIN_SHARE,
    data: isOpen,
    id
  });
}

export const SUBMIT_POPIN_SHARE = 'SUBMIT_POPIN_SHARE';
export function submitPopinShare(dispatch, form, confirmation) {
  sendShareForm(form)
    .then(json => dispatch({
      type: SUBMIT_POPIN_SHARE,
      data: json,
      confirmation,
      form
    }));
}

export const TOGGLE_POPIN_NEWSLETTER = 'TOGGLE_POPIN_NEWSLETTER';
export function togglePopinNewsletter(dispatch, isOpen, email) {
  dispatch({
    type: TOGGLE_POPIN_NEWSLETTER,
    isOpen,
    email
  });
}

export const SUBMIT_POPIN_NEWSLETTER = 'SUBMIT_POPIN_NEWSLETTER';
export function submitPopinNewsletter(dispatch, form, confirmation) {
  sendNewsletterForm(form)
    .then(json => dispatch({
      type: SUBMIT_POPIN_NEWSLETTER,
      data: json,
      confirmation
    }));
}



// WEBPACK FOOTER //
// ./src/actions/popin.js